import React, { Component, Fragment } from 'react';
import './CardPopup.Module.scss';
import Modal from 'react-responsive-modal';
import { history } from 'components/App/components/UnauthenticatedApp';
import ReactGA from 'react-ga';

import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import { faBolt, faChevronLeft, faCode, faHeart, faUsers, faUser, faClock, faCut, faDownload, faArrowToBottom , faArrowRight,} from '@fortawesome/pro-solid-svg-icons';

import {faHeart as faHeartRegular,} from '@fortawesome/pro-regular-svg-icons';

import{ faTimes as faTimesLight} from '@fortawesome/pro-light-svg-icons';

import {cardData} from 'utilities/card';
import Table1 from '../DeCultureleLadekast/DeCultureleLadekast';
import DeCultureleLadekast from '../DeCultureleLadekast/DeCultureleLadekast';
import CultuurStation from '../CultuurStation/CultuurStation';
import SLO from '../SLO/SLO';
import HeartButton from '../HeartButton/HeartButton';

class CardPopup extends Component {

    constructor() {
        super();
        this.state = {
            open: false,
            dropdownValue: 'ladekast'
        }

        this.handleChange       = this.handleChange.bind(this);
        this.trackDownload      = this.trackDownload.bind(this);
    }

    
    //scroll to top
    componentDidUpdate() {
        window.scrollTo(0,0);
    }

    componentDidMount() {
        window.scrollTo(0,0);
    }

    handleChange(e) {
        let {value} = e.target;
        this.setState({
            dropdownValue: value
        });
    }

    trackDownload(e) {
        ReactGA.event({
            category: "Lesmateriaal gedownload",
            action: "Lesmateriaal behorende bij les " + this.props.card.name + " gedownload",
        });
    }

    nl2br (str, is_xhtml) {
        // http://kevin.vanzonneveld.net
        // +   original by: Kevin van Zonneveld (http://kevin.vanzonneveld.net)
        // +   improved by: Philip Peterson
        // +   improved by: Onno Marsman
        // +   improved by: Atli Þór
        // +   bugfixed by: Onno Marsman
        // +      input by: Brett Zamir (http://brett-zamir.me)
        // +   bugfixed by: Kevin van Zonneveld (http://kevin.vanzonneveld.net)
        // +   improved by: Brett Zamir (http://brett-zamir.me)
        // +   improved by: Maximusya
        // *     example 1: nl2br('Kevin\nvan\nZonneveld');
        // *     returns 1: 'Kevin<br />\nvan<br />\nZonneveld'
        // *     example 2: nl2br("\nOne\nTwo\n\nThree\n", false);
        // *     returns 2: '<br>\nOne<br>\nTwo<br>\n<br>\nThree<br>\n'
        // *     example 3: nl2br("\nOne\nTwo\n\nThree\n", true);
        // *     returns 3: '<br />\nOne<br />\nTwo<br />\n<br />\nThree<br />\n'
        var breakTag = (is_xhtml || typeof is_xhtml === 'undefined') ? '<br ' + '/>' : '<br>'; // Adjust comment to avoid issue on phpjs.org display
      
        return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + breakTag + '$2');
      }

    getTags(tags) {
        var tagArray = [];
        var extraTags = 0;

        if(!tags) {
            return [];
        }

        for (var i = 0; i < tags.length; i++) {
            if(i < 2) {
                tagArray.push(tags[i]);
            }
            else {
                extraTags++;
            }
        }

        extraTags > 0 && tagArray.push('+' + extraTags);

        return tagArray;
    }



    render() {
        var { card } = this.props;

        if(!card) {
            return null;
        }

        let type = card.type;
        let slug = card.name.split(" ").join("-").toLowerCase();

        let cardColor;
        switch (card.level.toLowerCase()) {
            case 'intro':
                cardColor = '#FF3956';
                break;
            case 'basis':
                cardColor = '#FFCD2E';
                break;
            case 'gevorderd':
                cardColor = '#38D7D7';
                break;
            case 'expert':
                cardColor = '#6F3BFF';
                break;
        }
        return (
        <Fragment>
            <div styleName='modal'>
                <div styleName='background-image' style={{ backgroundColor:`${cardColor}`, minHeight: card.video ? '450px' : null}}>
                    {
                        card.video ?
                        <iframe allowFullScreen style={{width:'100%', height:'405px'}} src={`https://www.youtube.com/embed/${card.video}`} frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"></iframe>
                        :
                        <img styleName='modal-image' src={`/storage/${card.image}`} alt=''/>
                    }
                    
                    <p style={{backgroundColor:`${cardColor}`}}>{card.label} <b>{card.author}</b></p>
                    {
                        this.props.home &&
                        <div onClick={() => {history.push('/platform')}} style={{ backgroundColor:`${cardColor}`}} styleName='button'>
                            Naar het platform 
                            <FontAwesomeIcon style={{width:'12px', marginLeft: '8px'}} icon={faArrowRight}/>
                        </div>
                    }
                    {/* <div styleName='arrow-left'></div>
                    <div styleName='arrow-right'></div> */}
                </div>
                
                
                <div styleName='container-text'>
                    <div styleName='divider'>
                    <div styleName='container-text-grid'>
                        <div styleName='container-text-left'>
                            {
                                card.type == 'workshopcard' && <h1 styleName='h1-workshopcard'>WORKSHOP</h1>
                            }
                            <h1>{card.name}</h1>
                            <p dangerouslySetInnerHTML={{__html: this.nl2br(card.description)}} />
                            
                            <h4 styleName='artist-link-header'>Kunstenaar links</h4>
                               <div styleName={`artist-links ${card.level.toLowerCase()}`} dangerouslySetInnerHTML={{__html: card.artist_links}} />
                                
                            <h4 styleName='artist-link-header'>Praktische links</h4>
                            <div styleName={`artist-links ${card.level.toLowerCase()}`} dangerouslySetInnerHTML={{__html: card.practical_links}} />
                            {
                                card.type == 'workshopcard' &&
                                    <div styleName='modalform'>
                                
                                        <a href='mailto:educatie@mu.nl?subject=Workshop%20aanvragen' styleName='download-button'>Workshop of meer informatie aanvragen</a>
                                    </div>
                            }
                            
                        </div>
                        <div styleName='container-text-right'>
                            <div styleName='les-details-wrapper1'>
                                <h2 styleName=''>Les details</h2>
                                <HeartButton id={card.id}/>
                            </div>
                            <h4 styleName='h4-title'>{card.level}</h4>
                            {
                                card.level == 'Intro' && <p>Eerste kennismaking met kunst, code, computational thinking &amp; logica.</p>
                            }
                            {
                                card.level == 'Basis' && <p>In stappen aan de slag met blokken programmeertaal &amp; voor het eerst achter de computer, naast de nodige unplugged lessen.</p>
                            }
                            {
                                card.level == 'Gevorderd' && <p>Met scratch geef je zonder problemen instructie-codes aan je computer en maak een interactieve koppeling met kunst.</p>
                            }  
                            {
                                card.level == 'Expert' && <p>Als experts gaan kinderen echt als codekunstenaars aan de slag. Ze simuleren leven in een kweektuin door met processing en wiskunde aan de slag te gaan.</p>
                            }                               
                            <h3>Code &#38; techniek</h3>
                            <div styleName='technisch-bar'>
                                <div styleName='technisch-bar-content' style={{ width: `${card['code-tech-percentage'] * 10}%` , backgroundColor:`${cardColor}`}}>
                                
                                </div>
                            </div>
                            <h3>Kunst &#38; creativiteit</h3>
                            <div styleName='creative-bar'>
                                <div styleName='creative-bar-content' style={{ width: `${card['art-creativity-percentage'] * 10}%` , backgroundColor:`${cardColor}`}}>
                                
                                </div>
                            </div>
                            <h3>Kritisch denken</h3>
                            <div styleName='filosofisch-bar'>
                                <div styleName='filosofisch-bar-content' style={{ width: `${card['critical-thinking-percentage'] * 10}%` , backgroundColor:`${cardColor}`}}>
                                
                                </div>
                            </div>
                            <div styleName='label-wrapper'>
                                <div styleName='circle'>
                                    <div styleName='icon' >
                                    <FontAwesomeIcon  style={{width:'12px'}} icon={faCode}/>
                                    </div>
                                </div>
                                
                                { card.tags && 
                                card.tags.map((tags, index) => 
                                    <p index={index}>{tags}</p>
                                        )}
                                
                            </div>
                            <div styleName='icon-wrapper'>
                                <div styleName='icons-left'>
                                {
                                        card.plugged ?
                                    
                                    <div styleName='circle' style={{backgroundColor:`${cardColor}`}}>
                                        <div styleName='icon'>
                                        <FontAwesomeIcon icon={faBolt}/>
                                        </div>
                                    </div>
                                    :
                                    <div styleName='circle'style={{backgroundColor:`${cardColor}`}}>
                                        <div styleName='icon'>
                                        <FontAwesomeIcon icon={faCut}/>
                                        </div>
                                    </div>
                                    }
                                    {
                                        card.group_lesson ?
                                    
                                        <div styleName='circle' style={{backgroundColor:`${cardColor}`}}>
                                            <div styleName='icon'>
                                            <FontAwesomeIcon icon={faUsers}/>
                                            </div>
                                        </div>
                                        : null
                                    }
                                    {
                                        card.individual_lesson ?
                                    
                                        <div styleName='circle' style={{backgroundColor:`${cardColor}`}}>
                                            <div styleName='icon'>
                                            <FontAwesomeIcon icon={faUser}/>
                                            </div>
                                        </div>
                                        : null
                                    }
                                    <div styleName='circle' style={{backgroundColor:`${cardColor}`}}>
                                        <div styleName='icon'>
                                        <p>
                                            <FontAwesomeIcon icon={faClock}/> {card.time_min} min
                                        </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <h4 styleName='h4-title'>Benodigdheden</h4>
                                <p>{card.necessities}</p>
                            <h4 styleName='h4-title'>Bron</h4>
                                <p>{card.source}</p>
                            {
                                card.type == 'workshopcard' ?
                                null:
                                <Fragment>
                                    <h4 styleName='h4-title'>Download lesmateriaal</h4>
                                    {card.download_po && <a onClick={this.trackDownload} target="_blank" href={`/storage/${card.download_po}`} styleName='download-button'><FontAwesomeIcon icon={faArrowToBottom}/> PO</a> }
                                    {card.download_vo && <a onClick={this.trackDownload} target="_blank" href={`/storage/${card.download_vo}`} styleName='download-button'><FontAwesomeIcon icon={faArrowToBottom}/> VO</a> }
                                </Fragment>
                            }
                                        
                            
                        </div>
                    </div>
                    </div>
                    <div styleName='excel-container'>
                        <select style={{width:'220px'}} name="leermethode" onChange={this.handleChange}>
                            <option value="ladekast">De Culturele Ladekast</option>
                            <option value="cultuurstation">De Cultuurloper</option>
                            <option value="slo">SLO</option>
                        </select>
                        
                        { this.state.dropdownValue == 'ladekast' && 
                        <DeCultureleLadekast lesson={card} />
                        }
                        { this.state.dropdownValue == 'cultuurstation' && 
                        <CultuurStation lesson={card} />
                        }
                        { this.state.dropdownValue == 'slo' && 
                        <SLO lesson={card} />
                        }
                    </div>
                </div>
            </div>
        </Fragment>
        );
    }
}

export default CardPopup;
